export const ALLOWED_DOCUMENT_STATUS_FILTERS = ['pending', 'approved', 'rejected'];

export const DOC_CATEGORY_KEYS = [
  'proof_of_insurance',
  'proof_of_maintenance_record',
  'proof_of_ownership',
];

export const normalizeCategory = (category) => {
  const value = (category || '').toLowerCase();
  if (value.includes('insurance')) return 'proof_of_insurance';
  if (value.includes('maintenance')) return 'proof_of_maintenance_record';
  if (value.includes('ownership')) return 'proof_of_ownership';
  return value;
};

export const getDocumentsByCategory = (documents) => {
  const byCategory = {};
  (documents || []).forEach((doc) => {
    byCategory[normalizeCategory(doc.category)] = doc;
  });
  return byCategory;
};

export const getListingDocumentOverallStatus = (listing) => {
  const byCategory = getDocumentsByCategory(listing && listing.carDocuments);

  if (DOC_CATEGORY_KEYS.some((key) => {
    const doc = byCategory[key];
    return doc && doc.status === 'rejected';
  })) {
    return 'rejected';
  }

  if (DOC_CATEGORY_KEYS.every((key) => {
    const doc = byCategory[key];
    return doc && doc.status === 'approved';
  })) {
    return 'approved';
  }

  return 'pending';
};

const APPROVED_LISTINGS_SUBQUERY = `
  SELECT cd.listId
  FROM CarDocuments cd
  GROUP BY cd.listId
  HAVING
    SUM(CASE WHEN LOWER(cd.category) LIKE '%insurance%' AND cd.status = 'approved' THEN 1 ELSE 0 END) > 0
    AND SUM(CASE WHEN LOWER(cd.category) LIKE '%maintenance%' AND cd.status = 'approved' THEN 1 ELSE 0 END) > 0
    AND SUM(CASE WHEN LOWER(cd.category) LIKE '%ownership%' AND cd.status = 'approved' THEN 1 ELSE 0 END) > 0
    AND SUM(CASE WHEN cd.status IN ('pending', 'rejected') THEN 1 ELSE 0 END) = 0
`;

const REJECTED_LISTINGS_SUBQUERY = `
  SELECT DISTINCT listId FROM CarDocuments WHERE status = 'rejected'
`;

const PENDING_LISTINGS_SUBQUERY = `
  SELECT l.id FROM Listing l
  WHERE l.id NOT IN (${REJECTED_LISTINGS_SUBQUERY})
  AND l.id NOT IN (${APPROVED_LISTINGS_SUBQUERY})
`;

export function documentStatusListIdSubquery(documentStatusFilter) {
  if (documentStatusFilter === 'approved') {
    return APPROVED_LISTINGS_SUBQUERY;
  }
  if (documentStatusFilter === 'rejected') {
    return REJECTED_LISTINGS_SUBQUERY;
  }
  if (documentStatusFilter === 'pending') {
    return PENDING_LISTINGS_SUBQUERY;
  }
  return null;
}
